// extracted by mini-css-extract-plugin
export default {"imageWrapper":"NF-z","twoColumnImage":"OF-z"};